import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'

const DEFAULT_ROW = 48
class PrintReportProductTransactionRequestPurchase extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    getDataFormat(data) {
        let check_date = []
        let dataFormat = []
        let productcode = []
        let cost_per_unit = []
        let description = []
        let price_per_unit = []
        let quantity = []
        let unit = []
    
        data = data.map((item,index)=>{
            if (item.added_date!=''&&item.added_date!=null&&item.added_date!=undefined&&item.added_date.split(' ').length>0)
                item.added_date = item.added_date.split(' ')[0]
            
            return item
        })
    
        for (var i=0;i<data.length;i++) {
            if (check_date.indexOf(data[i].added_date)==-1) {
              check_date.push(data[i].added_date)
            }
        }
    
        for (var i=0;i<check_date.length;i++) {
            for (var j=0;j<data.length;j++) {
              if (check_date[i]==data[j].added_date) {
                productcode.push(data[j].productcode)
                cost_per_unit.push(data[j].cost_per_unit)
                description.push(data[j].description)
                price_per_unit.push(data[j].price_per_unit)
                quantity.push(data[j].quantity)
                unit.push(data[j].unit)
              }
            }
            dataFormat.push({
              added_date: check_date[i],
              meta: {
                productcode: productcode,  
                cost_per_unit: cost_per_unit,
                description: description,
                price_per_unit: price_per_unit,
                quantity: quantity,
                unit: unit
              }
            })
            productcode = []
            cost_per_unit = []
            description = []
            price_per_unit = []
            quantity = []
            unit = []
        }
        
        return dataFormat  
      }

    loadData() {
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined&&this.props.groupId!=undefined&&this.props.recordType!=undefined) {
            if (this.props.recordType=='adjust') {
                ReportStore.loadReportConsumablesProductTransactionRecord(this.props.year,this.props.month,this.props.day,'officemate','purchaseorder',this.props.groupId,(result)=>{
                    this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
                })
            } else {
                ReportStore.loadReportProductTransactionRecord(this.props.year,this.props.month,this.props.day,this.props.groupId,this.props.recordType,'',(result)=>{
                    this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
                })
            }       
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined&&this.props.groupId!=undefined&&this.props.recordType!=undefined) {
            if (this.props.recordType=='adjust') {
                ReportStore.loadReportConsumablesProductTransactionRecordRange(this.props.startDate,this.props.endDate,'officemate','purchaseorder',this.props.groupId,(result)=>{
                    this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
                })
            } else {    
                ReportStore.loadReportProductTransactionRecordRange(this.props.startDate,this.props.endDate,this.props.groupId,this.props.recordType,'',(result)=>{
                    this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
                })
            }    
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkDate = undefined
        let checkRow = 0
        data = data.map((item,index)=>{
            if (item.added_date!=''&&item.added_date!=null&&item.added_date!=undefined&&item.added_date.split(' ').length>0)
                item.added_date = item.added_date.split(' ')[0]
            
            return item
        })
        
        data.forEach((item,index)=>{
            if (checkRow<DEFAULT_ROW) {
                newData.push(item)
                checkRow++
                if (checkDate!=item.added_date) {
                    checkRow = checkRow+2
                }
                checkDate = item.added_date
            }
                
            if (checkRow>=DEFAULT_ROW-1||index==data.length-1) {
                allData.push(newData)
                checkRow = 0
                newData = []
            }
        })  
        
        return allData
    }

    renderDocDate(date) {
        return(
          <div className='bd-date'><b>{date}</b></div>
        )
      }
    
      renderCol(datas,key,status=true) {
        return(
          datas.map((data, index) => {
            return(
              <div key={index} className={(key=='productcode'?'font-18 ':'')+(datas.length-1==index&&key=='amount'?'bd-sum':'')}>
                {data!=''?data:<br/>}
              </div>
            )
          })
        )
      }

    renderRowData(items,indexs) {

        if (items.length==0) {
          return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
        } else {
          return(
            items.map((item,index) => {
              return(
                <tr key={index}>
                  <td>
                    {this.renderDocDate(item.added_date)}
                    {/* {this.renderCol(item.meta.productcode,'productcode')} */}
                  </td>
                  {/* <td className='text-center'>
                    <div className='bd-date'><br/></div>
                    {this.renderCol(item.meta.productcode,'productcode')}
                  </td>  */}
                  <td className='text-left' style={{whiteSpace:'nowrap',width:'100px',overflow:'hidden',textOverflow:'ellipsis'}}>
                    <div className='bd-date'><br/></div>
                    {this.renderCol(item.meta.description,'description')}
                  </td>
                  <td className='text-center'>
                    <div className='bd-date'><br/></div>
                    {this.renderCol(item.meta.quantity,'quantity')}
                  </td>
                  <td className='text-center'>
                    <div className='bd-date'><br/></div>
                    {this.renderCol(item.meta.unit,'unit')}
                  </td>
                  <td className='text-right'>
                    <div className='bd-date'><br/></div>
                    {this.renderCol(item.meta.cost_per_unit,'cost_per_unit')}
                  </td>
                  <td className='text-right'>
                    <div className='bd-date'><br/></div>
                    {this.renderCol(item.meta.price_per_unit,'price_per_unit')}
                  </td> 
                </tr>
              )
            })
          )
        }
    }

    renderTable(items,indexs,length) {
        return(
            <table className='table table-responsive table-report-po-print'>
                <thead>
                    <tr>
                        <td className='text-center' style={{width:'200px'}}>วันที่</td>
                        <td className='text-center' style={{width:'350px'}}>ชื่ออะไหล่</td>
                        <td className='text-center' style={{width:'80px'}}>จำนวน</td>
                        <td className='text-center' style={{width:'80px'}}>หน่วย</td>
                        <td className='text-center' style={{width:'100px'}}>ต้นทุน</td>
                        <td className='text-center' style={{width:'120px'}}>ราคาขาย</td>
                    </tr>
                </thead>
                <tbody>
                    {this.renderRowData(items,indexs)}
                    {length-1===indexs?
                    <tr>
                        <td colSpan={2} className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-center'>{this.getSummary('quantity')}</td>
                        <td className='text-right'></td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('cost_per_unit'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('price_per_unit'))}</td>
                    </tr>
                    :''}
                </tbody>    
            </table>
        )
    }

    renderComponentPage(items,indexs,length) {
        let {recordType} = this.props
        return(  
            <div className='font-print' key={indexs}>
                <header className="text-center">
                    <h2>{recordType=='request_purchase'?this.props.title:recordType=='purchaseorder'?'ตารางรายงานสรุปยอดจัดซื้อ':'ตารางรายงานสรุปรับวัสดุสิ้นเปลืองจากใบสั่งซื้อ'}</h2>
                </header>
                <div>
                    {this.renderTable(items,indexs,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        let {recordType} = this.props
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={recordType=='request_purchase'?this.props.title:recordType=='purchaseorder'?'ตารางรายงานสรุปยอดจัดซื้อ':'ตารางรายงานสรุปรับวัสดุสิ้นเปลืองจากใบสั่งซื้อ'}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={recordType=='request_purchase'?this.props.title:recordType=='purchaseorder'?'ตารางรายงานสรุปยอดจัดซื้อ':'ตารางรายงานสรุปรับวัสดุสิ้นเปลืองจากใบสั่งซื้อ'}
                >
                    {
                        dataList.map((item,index)=>{
                            let items = this.getDataFormat(item)
                            return(
                                this.renderComponentPage(items,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportProductTransactionRequestPurchase.defaultProps = {
    title: 'ตารางรายงานสรุปยอดขอสั่งซื้อ',  
    mode: '',
    workNo: '',
    recordType: 'request_purchase'
  }
  export default PrintReportProductTransactionRequestPurchase;


// WEBPACK FOOTER //
// ./src/view/print/stock/PrintReportProductTransactionRequestPurchase.js